import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import ForCompanies from './components/ForCompanies';
import ForProfessionals from './components/ForProfessionals';
import Industries from './components/Industries';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-['Inter',system-ui,sans-serif]">
      <Header />
      <main>
        <Hero />
        <Services />
        <ForCompanies />
        <ForProfessionals />
        <Industries />
      </main>
      <Footer />
    </div>
  );
}
